<div>
    <h2>{{'mantenimientoEnvases.titulo' | translate}}</h2>
    <section class="filters-framed" *ngIf="filtersVisible">
        <form [formGroup]="filtersForm" [ngClass]="{'show-error': showError}">
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
                <label>{{'mantenimientoEnvases.filters.etiquetador' | translate}}</label>
                <app-filterable-list [itemsList]="etiquetadores" [selectedItem]="filtersForm.get('etiquetador')" [placeHolder]="false">
                </app-filterable-list>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
                <label>{{'mantenimientoEnvases.filters.envase' | translate}}</label>
                <input type="text" formControlName="envase">
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'" class="calendar">
                <label>{{'global.fecha.inicio' | translate}}</label>
                <input [matDatepicker]="fechaInicio" placeholder="{{'global.fecha.placeholder' | translate}}" formControlName="fechaInicio"
                    (click)="fechaInicio.open()">
                <mat-datepicker #fechaInicio></mat-datepicker>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'" class="calendar">
                <label>{{'global.fecha.fin' | translate}}</label>
                <input [matDatepicker]="fechaFin" placeholder="{{'global.fecha.placeholder' | translate}}" formControlName="fechaFin"
                    (click)="fechaFin.open()">
                <mat-datepicker #fechaFin></mat-datepicker>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'" class="radio-group no-margin-left">
                <input type="radio" id="insercion" value="false" formControlName="dateType">
                <label for="insercion">{{'global.fecha.insercion' | translate}}</label>
                <input type="radio" id="actualizacion" value="true" formControlName="dateType">
                <label for="actualizacion">{{'global.fecha.actualizacion' | translate}}</label>
            </div>
            <div *ngIf="this.isSmallScreen" class="entry-3-small"></div>
        </form>
    </section>
    <section class="filters-buttons">
        <button *ngIf="!filtersVisible" [ngClass]="{'showFilters': filtersVisible}"
            (click)="filtersVisible=!filtersVisible" title="{{'global.filtros.abrir' | translate}}">
            <i class="fas fa-filter"></i> {{'global.filtros.filtrar' | translate}}
        </button>
        <button *ngIf="filtersVisible" class="secondary" [ngClass]="{'showFilters': filtersVisible}"
            (click)="filtersVisible=!filtersVisible" title="{{'global.filtros.cerrar' | translate}}">
            <i class="fas fa-times"></i> {{'global.filtros.cerrar' | translate}}
        </button>
        <button *ngIf="filtersVisible" class="secondary"
            [ngClass]="{'showFilters': filtersVisible, 'secondary-disabled': !checkValuesForm()}" (click)="resetForm()"
            title="{{'global.filtros.limpiar' | translate}}">
            <i class="fas fa-eraser"></i> {{'global.filtros.limpiar' | translate}}
        </button>
        <button *ngIf="filtersVisible" [ngClass]="{'showFilters': filtersVisible}"
            title="{{'global.filtros.filtrar' | translate}}" (click)="filtrar()">
            <i class="fas fa-filter"></i> {{'global.filtros.aplicar' | translate}}
        </button>
    </section>
    <section class="export-buttons">
      <i class="fas fa-file-pdf"
          [ngClass]="{'disabled': !envases || (envases && envases.length < 1)}"
          (click)="exportPdfOrCsv('pdf')" title="{{'titles.exportarPDF' | translate}}"></i>
      <i class="fas fa-file-csv"
          [ngClass]="{'disabled': !envases || (envases && envases.length < 1)}"
          (click)="exportPdfOrCsv('csv')" title="{{'titles.exportarCSV' | translate}}"></i>
      <i class="fa-solid fa-circle-question" (click)="openDocHelp()" title="{{'global.obtenerAyuda' | translate}}"></i>
    </section>
    <div class="table-wrapper">
        <div class="table-container">
            <table>
                <thead>
                    <tr>
                        <th class="id sortable" (click)="toOrderBy('x=> x.id', 1)">
                          {{'mantenimientoEnvases.table.id' | translate}}
                          <i [ngClass]="getIcon('x=> x.id')"></i>
                        </th>
                        <th class="string sortable sortable-biggest" (click)="toOrderBy('x=> x.etiquetador.des', 2)">
                          {{'mantenimientoEnvases.table.etiquetador' | translate}}
                          <i [ngClass]="getIcon('x=> x.etiquetador.des')"></i>
                        </th>
                        <th class="string sortable sortable-biggest" (click)="toOrderBy('x=> x.des', 3)">
                          {{'mantenimientoEnvases.table.envase' | translate}}
                          <i [ngClass]="getIcon('x=> x.des')"></i>
                        </th>
                        <th class="string sortable" (click)="toOrderBy('x=> x.kilos', 4)">
                          {{'mantenimientoEnvases.table.peso' | translate}}
                          <i [ngClass]="getIcon('x=> x.kilos')"></i>
                        </th>
                        <th class="date-long sortable" (click)="toOrderBy('x=> x.fechaIns', 5)">
                          {{'global.fecha.insercionShort' | translate}}
                          <i [ngClass]="getIcon('x=> x.fechaIns')"></i>
                        </th>
                        <th class="date-long sortable" (click)="toOrderBy('x=> x.fechaUpd', 6)">
                          {{'global.fecha.actualizacionShort' | translate}}
                          <i [ngClass]="getIcon('x=> x.fechaUpd')"></i>
                        </th>
                        <th class="actions">
                          <i class="fas fa-plus" *ngIf="this.role === 'Administrador' || this.claims.includes('ENV_Ins')"
                              (click)="create()" title="{{'mantenimientoEnvases.tituloNew' | translate}}"></i>
                        </th>
                    </tr>
                </thead>
                <tbody *ngFor="let envase of envases; trackBy: trackByEnvaseId">
                    <tr>
                        <td class="id">{{envase.id}}</td>
                        <td class="string-longest">{{envase.desEtiquetador}}</td>
                        <td class="string-longest">{{envase.des}}</td>
                        <td class="string">{{envase.kilos | number : '.2' : defaultLanguage}}</td>
                        <td class="date-long">{{envase.fechaIns | date: 'shortDate' : undefined : defaultLanguage}}</td>
                        <td class="date-long">{{envase.fechaUpd | date: 'shortDate' : undefined : defaultLanguage}}</td>
                        <td class="actions">
                            <i class="fas fa-pencil-alt" *ngIf="this.role === 'Administrador' || this.claims.includes('ENV_Upd')"
                                (click)="update(envase)" title="{{'titles.editar' | translate}}"></i>
                            <i class="far fa-trash-alt" *ngIf="this.role === 'Administrador' || this.claims.includes('ENV_Del')"
                                [ngClass]="{'disabled': envase.registroEnUso}" (click)="askDelete(envase)" title="{{'titles.eliminar' | translate}}"></i>
                        </td>
                    </tr>
                </tbody>
                <tfoot *ngIf="!envases || (envases && envases.length < 1)">
                    <tr>
                        <td colspan="8">
                            {{'global.noContent' | translate}}
                        </td>
                    </tr>
                </tfoot>
            </table>
        </div>
    </div>
    <app-paginator *ngIf="envases && envases.length > 0" [itemsPerPage]="itemsPerPage" [currentPage]="currentPage + 1"
        [totalItems]="totalItems" [visiblePages]="visiblePages" (pageChange)="pageChange($event)"
        (itemsPerPageChange)="itemsPerPageChange($event)"></app-paginator>
    <app-toast *ngIf="(showError) && mensajes" [messages]="mensajes" (closed)="showError=$event">
    </app-toast>
</div>
<div class="modal" *ngIf="deleteModal">
    <div class="modal-content">
        <header>
            <h4>{{ 'global.eliminar.descripcion' | translate }}</h4>
        </header>
        <content>
            <p>{{ 'global.eliminar.confirmacion' | translate }}</p>
        </content>
        <footer>
            <button class="secondary" (click)="close()">{{'global.cancelar' | translate}}</button>
            <button (click)="delete()">{{'global.confirmar' | translate}}</button>
        </footer>
    </div>
</div>
<div class="modal" *ngIf="newEditModal">
    <div class="modal-content">
        <header>
            <h4>{{envaseId ? ('mantenimientoEnvases.tituloEdit' | translate) : ('mantenimientoEnvases.tituloNew' | translate)}}
            </h4>
        </header>
        <app-mantenimientoEnvases-new-edit [envaseId]="envaseId" (refresh)="refresh($event)" (mensaje)="pushMessage($event)">
        </app-mantenimientoEnvases-new-edit>
    </div>
</div>
